
import { Component, Prop, Vue } from 'vue-property-decorator';
import type { QoutAllRow } from '@/pages/customCalculation/model';
import BulkQoutAllOperation from './BulkQoutAllOperation.vue';

/**
 * 放流量条件設定の操作系（計算実行・降雨条件設定への戻り・一括操作）をまとめたパネル。
 * 広い画面ではテーブル横に、狭い画面ではダイアログ内に置くため、配置を持たない形で切り出している。
 */
@Component({
  components: {
    BulkQoutAllOperation,
  },
})
export default class QoutAllOperationPanel extends Vue {
  @Prop({ type: Array, required: true })
  data!: QoutAllRow[];

  @Prop({ type: Boolean, default: false })
  isCalculating!: boolean;
}
